"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var BluehostModule = /** @class */ (function (_super) {
    __extends(BluehostModule, _super);
    function BluehostModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询俱乐部列表
     * @param clubName 	俱乐部名称
     * @param clubNo 俱乐部编号
     * @param developer 开发人员姓名/手机号
     * @param endDate	创建日期止
     * @param maker	创客姓名/手机号
     * @param page	页数
     * @param size	行数
     * @param startDate	创建日期起
     * @param token
     */
    BluehostModule.prototype.queryClubList = function (params, token) {
        return this.gatewayClient.queryClubList(params, token);
    };
    /**
     * 检查俱乐部名称是否可用
     * @param name 	俱乐部名称
     */
    BluehostModule.prototype.checkClubName = function (name, token) {
        return this.gatewayClient.checkClubName(name, token);
    };
    /**
     * 编辑俱乐部名称
     * @param clubName 	俱乐部名称
     * @param id 	俱乐部名称
     * @param updateName 	俱乐部名称
     */
    BluehostModule.prototype.editClubName = function (clubName, id, updateName, token) {
        return this.gatewayClient.editClubName(clubName, id, updateName, token);
    };
    /**
     * 查看俱乐部所有成员
     * @param clubId 	俱乐部ID
     * @param token
     */
    BluehostModule.prototype.clubMemberList = function (clubId, token) {
        return this.gatewayClient.clubMemberList(clubId, token);
    };
    /**
     * 根据蓝主人id查询签约意向对象
     * @param ownerId
     * @param token
     */
    BluehostModule.prototype.querySignIntentionInfo = function (ownerId, token) {
        return this.gatewayClient.querySignIntentionInfo(ownerId, token);
    };
    /**
     * 修改签约意向对象
     * @param params
     * @param token
     */
    BluehostModule.prototype.editIntention = function (params, token) {
        return this.gatewayClient.editIntention(params, token);
    };
    /**
     * 新增签约意向对象
     * @param params
     * @param token
     */
    BluehostModule.prototype.addIntention = function (params, token) {
        return this.gatewayClient.addIntention(params, token);
    };
    /**
     * 查询代理
     */
    BluehostModule.prototype.getAgent = function (token) {
        return this.gatewayClient.getAgent(token);
    };
    /**
     * 查询代理
     */
    BluehostModule.prototype.getSubsidiary = function (token) {
        return this.gatewayClient.getSubsidiary(token);
    };
    /**
     * 修改签约来源
     * @param clubId	俱乐部id	number
     * @param contractOnlineId	合同id	number
     * @param makerId	创客id	number
     * @param signSource	signSourceType为4、5时分别对应代理、子公司	string
     * @param signSourceType	签约类型：1 开发，2贵州样板事业部，3创客/俱乐部，4代理，5子公司	number
     * @param updateName	操作人	string
     */
    BluehostModule.prototype.putSignSource = function (params, token) {
        return this.gatewayClient.putSignSource(params, token);
    };
    /**
     * 修改合同收款记录
     * @param contractOnlineId	合同id	number
     * @param isPayBondFee	是否支付总保证金：1是，0否	number
     * @param isPayPlatformFee	是否支付总授权费：1是，0否	number
     * @param receipBondFee	实收总保证金，单位：分;	number
     * @param receipPlatformFee	实收总授权费，单位：分	number
     * @param updateName	操作人	string
     */
    BluehostModule.prototype.putContractFeeRecord = function (params, token) {
        return this.gatewayClient.putContractFeeRecord(params, token);
    };
    /**
     * 合同协议操作记录列表
     * @param contractOnlineId	合同id	number
     * @param page	页码	number
     * @param pageSize	每页数	number
     * @param keyword	查询的字符串	string
     */
    BluehostModule.prototype.getOperateRecord = function (params, token) {
        return this.gatewayClient.getOperateRecord(params, token);
    };
    /**
     * 获得蓝主任公司代理信息
     */
    BluehostModule.prototype.getCompanyAgencyInfo = function (data) {
        return this.gatewayClient.getCompanyAgencyInfo(data);
    };
    /**
     * 获得蓝主任公司代理信息增加
     */
    BluehostModule.prototype.AgencyAdd = function (data, token) {
        return this.gatewayClient.AgencyAdd(data, token);
    };
    /**
     * 根据蓝主人公司代理编辑
     * @param ownerId
     * @param token
     */
    BluehostModule.prototype.updateAgency = function (data, token) {
        return this.gatewayClient.updateAgency(data, token);
    };
    BluehostModule.prototype.getAgencyFindAll = function (data, token) {
        if (data === void 0) {
            data = {};
        }
        return this.gatewayClient.getAgencyFindAll(data, token);
    };
    /**
     * 房源匹配接口    同步到ruby的房源发布
     * @param json_data	json字符串
     */
    BluehostModule.prototype.postSetSync = function (params, token) {
        return this.gatewayClient.postSetSync(params, token);
    };
    return BluehostModule;
}(gateway_module_1.GatewayModule));
exports.BluehostModule = BluehostModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9ibHVlaG9zdC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFFQSxvREFBa0Q7QUFFbEQ7SUFBb0Msa0NBQWE7SUFBakQ7O0lBMFBBLENBQUM7SUF6UEM7Ozs7Ozs7Ozs7O09BV0c7SUFDSSxzQ0FBYSxHQUFwQixVQUNFLE1BU0MsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsYUFBYSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUN6RCxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksc0NBQWEsR0FBcEIsVUFBcUIsSUFBWSxFQUFFLEtBQWE7UUFDOUMsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsYUFBYSxDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztJQUN2RCxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxxQ0FBWSxHQUFuQixVQUNFLFFBQWdCLEVBQ2hCLEVBQVUsRUFDVixVQUFrQixFQUNsQixLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsWUFBWSxDQUFDLFFBQVEsRUFBRSxFQUFFLEVBQUUsVUFBVSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzFFLENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksdUNBQWMsR0FBckIsVUFBc0IsTUFBYyxFQUFFLEtBQWE7UUFDakQsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsY0FBYyxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUMxRCxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLCtDQUFzQixHQUE3QixVQUE4QixPQUFlLEVBQUUsS0FBYTtRQUMxRCxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxzQkFBc0IsQ0FBQyxPQUFPLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDbkUsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxzQ0FBYSxHQUFwQixVQUNFLE1BbUJDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGFBQWEsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDekQsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxxQ0FBWSxHQUFuQixVQUNFLE1Ba0JDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDeEQsQ0FBQztJQUVEOztPQUVHO0lBQ0ksaUNBQVEsR0FBZixVQUFnQixLQUFhO1FBQzNCLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUM1QyxDQUFDO0lBRUQ7O09BRUc7SUFDSSxzQ0FBYSxHQUFwQixVQUFxQixLQUFhO1FBQ2hDLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUNqRCxDQUFDO0lBRUQ7Ozs7Ozs7O09BUUc7SUFDSSxzQ0FBYSxHQUFwQixVQUNFLE1BT0MsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsYUFBYSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUN6RCxDQUFDO0lBRUQ7Ozs7Ozs7O09BUUc7SUFDSSw2Q0FBb0IsR0FBM0IsVUFDRSxNQU9DLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLG9CQUFvQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNoRSxDQUFDO0lBRUQ7Ozs7OztPQU1HO0lBQ0kseUNBQWdCLEdBQXZCLFVBQ0UsTUFLQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxnQkFBZ0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDNUQsQ0FBQztJQUVEOztPQUVHO0lBQ0ksNkNBQW9CLEdBQTNCLFVBQTRCLElBQVM7UUFDbkMsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsb0JBQW9CLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdkQsQ0FBQztJQUNEOztPQUVHO0lBQ0ksa0NBQVMsR0FBaEIsVUFBaUIsSUFBUyxFQUFFLEtBQWE7UUFDdkMsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsU0FBUyxDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNuRCxDQUFDO0lBQ0Q7Ozs7T0FJRztJQUNJLHFDQUFZLEdBQW5CLFVBQW9CLElBQVMsRUFBRSxLQUFhO1FBQzFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLFlBQVksQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDdEQsQ0FBQztJQUNNLHlDQUFnQixHQUF2QixVQUF3QixJQUFTLEVBQUUsS0FBYTtRQUM5QyxFQUFFLENBQUMsQ0FBQyxJQUFJLEtBQUssS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ3BCLElBQUksR0FBRyxFQUFFLENBQUM7UUFDWixDQUFDO1FBQ0QsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsZ0JBQWdCLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzFELENBQUM7SUFFRDs7O09BR0c7SUFDSSxvQ0FBVyxHQUFsQixVQUNFLE1BR0MsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsV0FBVyxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUN2RCxDQUFDO0lBQ0gscUJBQUM7QUFBRCxDQUFDLEFBMVBELENBQW9DLDhCQUFhLEdBMFBoRDtBQTFQWSx3Q0FBYyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/bluehost/index.js
// module id = 216
// module chunks = 44